import type { ReactNode } from "react";

interface ReviewsTrackProps {
  children: ReactNode;
  currentIndex: number;
}

const FULL_WIDTH_PERCENT = 100,

  /*
    The carousel's strip of slides, moved along to show the current one.

    Vertical padding only. The clip is what keeps the neighbouring slides out of
    sight, but it was cutting the card's own drop shadow off flush at the top and
    bottom edges. Padding gives the shadow room inside the clip; horizontal padding
    would do the same for the neighbours, which is exactly what we don't want.
  */
  ReviewsTrack = ({ children, currentIndex }: ReviewsTrackProps): ReactNode => (
    <div className="jobsite:overflow-hidden jobsite:py-4">
      <div
        className="jobsite:flex jobsite:transition-transform jobsite:duration-500 jobsite:ease-in-out"
        style={{
          transform: `translateX(-${currentIndex * FULL_WIDTH_PERCENT}%)`,
        }}
      >
        {children}
      </div>
    </div>
  );

export { ReviewsTrack };
